var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHideIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.18057 2.15288C1.91209 1.8844 1.91209 1.4491 2.18057 1.18061C2.44906 0.912127 2.88436 0.912127 3.15284 1.18061L17.8195 15.8473C18.088 16.1158 18.088 16.5511 17.8195 16.8196C17.551 17.088 17.1157 17.088 16.8472 16.8196L14.256 14.2283C12.9642 14.9317 11.5217 15.4167 10 15.4167C6.50248 15.4167 3.42341 12.8544 1.6306 10.9681C0.56763 9.84967 0.567631 8.15049 1.6306 7.03209C2.39127 6.23176 3.3835 5.30971 4.541 4.51331L2.18057 2.15288ZM7.63079 7.6031C7.38887 8.01252 7.25004 8.49009 7.25004 9.00008C7.25004 10.5189 8.48126 11.7501 10 11.7501C10.51 11.7501 10.9876 11.6113 11.397 11.3693L7.63079 7.6031ZM10 2.58341C13.4976 2.58341 16.5767 5.1458 18.3695 7.03209C19.4325 8.15049 19.4325 9.84967 18.3695 10.9681C17.9661 11.3925 17.4976 11.8512 16.9738 12.3071L7.62835 2.96167C8.3887 2.72326 9.18295 2.58341 10 2.58341Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideIcon);
export default __webpack_public_path__ + "static/media/hide-icon.f84f47e1eb6904441f38dc1429152b39.svg";
export { ForwardRef as ReactComponent };